import type { BaseTranslation } from "../i18n-types";

const mt = {
	WELCOME_LONG: "Merħba fil-Kamra tal-Qorti Diġitali Unicorn",
	WELCOME: "Merħba {name:string}!",
	JOIN_ROOM_DESCRIPTION:
		"Ingħaqad ma' kamra mniżżla hawn taħt jew ħoloq il-kamra tiegħek!",
	NO_ROOM: "Ma tara l-kamra li qed tfittex? Ħoloq il-kamra tiegħek stess.",
	CREATE_ROOM: "Oħloq Kamra",
	ROOM: "Kamra",
	ACCESSIBILITY_SETTINGS: "Issettjar tal-Aċċessibilità",
	ACCESSIBILITY_SETTINGS_DESCRIPTION:
		"Biddel issettjar ta' aċċessibilità hawnhekk",
	CONTRAST: "Kontrast",
	SELECT_DISPLAY_NAME: "Jekk jogħġbok daħħal l-isem li trid turi",
	SOMETHING_WENT_WRONG: "Uh oh! Xi ħaġa ġiet ħażin.",
	GO_BACK: "Mur Lura",
	GO_BACK_TO_ROOM: "Lura lejn il-Kamra",
	EXPAND: "Espandi",
	EXPORT: "Esporta",
	JOIN_ROOM: "Ingħaqad il-Kamra",
	ROOM_ENDED_TITLE: "Kamra Terminata",
	ROOM_ENDED_DESCRIPTION:
		"Il-kamra terminat, ser tiġi rrindirizzata lejn l-iskrin prinċipali",
	RENAME_FAILED: "It-tibdil tal-isem falliment.",
	TRANSCRIPT_DISCLAIMER:
		"Trascrizzjoni bbażata fuq is-sitwaturi identifikati. Trid titkellem għal aktar minn 7 sekondi biex tkun identifikat.",
	CHANGE_SPEAKER_TITLE: "Ibdel is-sitwatur",
	CHANGE_SPEAKER_DESCRIPTION: "Ibdel isem u l-kulur tas-sitwatur hawnhekk",
	PREVIEW_MESSAGE: "Din hija messaġġ ta' previżjoni",
	COLOR: "Kulur",
	NAME: "Isem",
	CANCEL: "Ikkanċella",
	LANGUAGE: "Lingwa",
	SAVE: "Salva Bidliet",
	ROOM_ID: "ID tal-Kamra",
	ROOM_ID_FORM_PLACEHOLDER: "Daħħal l-ID tal-kamra biex tingħaqad",
	ROOM_ID_FORM_REQUIRED: "L-ID tal-kamra huwa meħtieġ biex tingħaqad",
	ROOM_ID_FORM_MIN_LENGTH: "L-ID tal-kamra għandu jkun ta' 17 karattru",
	LOGIN: "Idħol",
	ROOM_COL: "Kamra:",
	LANGUAGE_COL: "Lingwa",
	END_ROOM: "Terminaw il-Kamra",
	JOIN_NOW: "Ingħaqad Issa",
	LOGIN_FORM: {
		TOAST_TITLE: "Idħalt!",
		TOAST_DESCRIPTION: "Issa tista' toħloq/tingħaqad ma' kamra!",
		DISPLAY_NAME: "Isem li jidhru",
		DISPLAY_NAME_FORM_PLACEHOLDER: "Daħħal l-isem tal-wiri",
		DISPLAY_NAME_FORM_SHORT:
			"L-isem li jidhru għandu jkun ta' mill-inqas 3 karattri",
		DISPLAY_NAME_FORM_LONG:
			"L-isem li jidhru għandu jkun ta' massimu 32 karattru",
		DISPLAY_NAME_FORM_REQUIRED: "L-isem li jidhru huwa meħtieġ",
	},
	PROFILE_FORM: {
		TITLE: "Ikkmpleta l-Profil Tiegħek",
		DESCRIPTION: "Jekk jogħġbok daħħal l-isem li trid turi biex tibda",
		TOAST_SUCCESS_TITLE: "Profil Aġġornat!",
		TOAST_SUCCESS_DESCRIPTION: "Il-profil tiegħek ġie salvat b'suċċess.",
		TOAST_ERROR_TITLE: "Aġġornament Fallut",
		TOAST_ERROR_DESCRIPTION:
			"Ma rnexxiex jaġġorna l-profil tiegħek. Jekk jogħġbok erġa' pprova.",
		SUBMIT_BUTTON: "Salva l-Profil",
	},
	DIARIZATION: {
		UNDETECTED: "Mhux magħruf",
		ACCURACY: "Aċċurattività",
		ID: "ID",
		LEXICAL: "Lexical",
		ITN: "ITN",
		MASKED_ITN: "ITN mħassal",
		LANGUAGE: "Lingwa",
		ORIGINAL_TEXT: "Iċċar",
		SPEAKER: "Sitwatur",
	},
	NO_ROOMS_LIST: "Oops, ma nistax insib xi kamri.",
	SEARCH_FOR_A_ROOM: "Fittex għal kamra",
	AUTH_ERROR_DESCRIPTION:
		"Kien hemm problema fl-awtentikazzjoni tiegħek. Jekk jogħġbok, rinfreżja.",
	DELETE_CONFIRMATION_MODAL: {
		TITLE: "Ħassar il-Kamra",
		DESCRIPTION: "Int żgur li trid tħassar din il-kamra?",
		CANCEL: "Ikkanċella",
		DELETE: "Ħassar",
	},
	CREATE_ROOM_TOAST: {
		TITLE: "Kamra Maħluqa",
		DESCRIPTION: "Il-kamra tiegħek lesta biex tingħaqad.",
	},
	CREATE_ROOM_FORM: {
		DESCRIPTION: "Agħti isem għall-kamra tiegħek biex l-oħrajn jarawha.",
		NAME_LABEL: "Isem tal-Kamra",
		NAME_PLACEHOLDER: "Ikteb l-isem tal-kamra",
		LANGUAGE: "Lingwa",
		LANGUAGE_PLACEHOLDER: "Agħżel lingwa",
		AUTO_DETECT: "Awtodetekta",
		ENGLISH_US: "Ingliż (Stati Uniti)",
		ENGLISH_IN: "Ingliż (Indja)",
		ARABIC_KSA: "Għarbi (Arabja Sawdi)",
		SPANISH_CR: "Spanjol (Kosta Rika)",
		CATALAN_ES: "Katalan (Spanja)",
		PORTUGUESE_PT: "Portugiż (Portugall)",
		PORTUGUESE_BR: "Portugiż (Brazil)",
		ESTONIAN_EE: "Estonjan (Estonja)",
		RUSSIAN_RU: "Russu (Russja)",
		MALTESE_MT: "Malti (Malta)",
		FILIPINO_PH: "Filippina (Filippini)",
		LANGUAGE_DESCRIPTION:
			"Agħżel lingwa għall-kamra, ma tistax tbiddel il-lingwa tal-kamra wara.",
		INCPERSONDEFAULT: "Doe,Jane",
		CDCDEFAULT: "AB1234",
		HEARINGTYPEDEFAULT: "Udienza ta' Adegwatezza Sussegwenti",
		SCHEDULEDEFAULT: "11/28/2023, 10:30 am PST",
		ADVANCED: "Issettjar Avvanzat",
		INCARCERATED_PERSON_PLACEHOLDER: "Daħħal ismek",
		CDC_PLACEHOLDER: "Daħħal in-numru CDC",
		HEARING_TYPE_PLACEHOLDER: "Daħħal it-tip ta' udienza",
		INCARCERATED_PERSON: "Persuna inkarċerata",
		CDC: "CDC",
		HEARING_TYPE: "Tip ta' Udienza",
		SCHEDULE: "Skeda",
		PICKDATE: "Agħżel data",
		HOURS: "Siegħat",
		MINUTES: "Minuti",
		SECONDS: "Sekondi",
	},
	EXPORT_MODAL: {
		TOAST_FAILED_TITLE: "Esportazzjoni Fallita",
		TOAST_FAILED_DESCRIPTION: "Ma tistax tesporta trascrizzjoni vojta.",
		DOWNLOAD: "Niżżel",
		DOWNLOAD_DESCRIPTION:
			"Agħżel il-format għall-esportazzjoni u attiva għażliet addizzjonali.",
		SELECT_FORMAT: "Agħżel il-format",
		SELECT_FORMAT_PLACEHOLDER: "Agħżel il-format ta' esportazzjoni",
		DOCUMENT: "Dokument (.pdf)",
		SPREADSHEET: "Fajl ta' kalkolu (.csv)",
		AUDIO: "Audio (.mp3)",
		DOCX: "Dokument Word (.docx)",
	},
	TRANSLATE_DIALOG: {
		TITLE: "Traduzzjoni",
		BODY: "Tixtieq tapplika din il-bidla fuq it-trascrizzjonijiet kollha ta' dan l-utent?",
		APPLY_TO_SPEAKER: "Applika biss għal dan l-utent",
		APPLY_ONCE: "Applika hawn biss",
		APPLY_TO_ALL: "Applika għal kulħadd",

		TRANSLATE: "Ittraduċi",
	},
	GUEST_FORM: {
		TITLE: "Aċċess ta' Mistieden",
		DESCRIPTION:
			"Daħħal l-indirizz tal-email tiegħek biex tirċievi link ta' dħul sikur",
		EMAIL_LABEL: "Indirizz tal-Email",
		EMAIL_PLACEHOLDER: "Daħħal l-indirizz tal-email",
		EMAIL_REQUIRED: "L-indirizz tal-email huwa meħtieġ",
		EMAIL_INVALID: "Jekk jogħġbok daħħal indirizz tal-email validu",
		SEND_LINK: "Ibgħat Link ta' Dħul",
		SUCCESS_TITLE: "Iċċekkja l-Email Tiegħek",
		SUCCESS_DESCRIPTION:
			"Bgħatna link ta' dħul fl-indirizz tal-email tiegħek. Ikklikkja fuq il-link biex taċċessa l-kamra.",
		ERROR_TITLE: "Xi ħaġa ġiet ħażin",
		ERROR_DESCRIPTION:
			"Ma rnexxiex nibgħatu l-link ta' dħul. Jekk jogħġbok erġa' pprova.",
		CANCEL: "Ikkanċella",
	},
	START_DATE_TIME: "Data u Ħin tal-Ħin",
	END_DATE_TIME: "Data u Ħin tal-Fin",
	REVERT_TO_ORIGINAL: "Ritorna għall-Original",
	SELECTED_LANGUAGE: "Lingwa Selezzjonata",
	TRANSLATION_INFO: "Xi trascrizzjonijiet huma ittraduċi mill-original.",
	INVITE_GUEST: "Invita Mistieden",
	INVITE_GUEST_DESCRIPTION:
		"Invita utent għall-għamara billi ddaħħal isimhom u l-indirizz tal-email tagħhom",
	CREATED_BY: "Maħluq minn",
	VIEW_ALL: "Ara Kollha",
	LOBBY: {
		LOBBY: "Lobby",
		WAITING_IN_LOBBY: "{name} qed jistenna fil-lobby",
		USERS_WAITING_IN_LOBBY:
			"Immaniġġja utenti li bħalissa qed jistennew fil-lobby.",
		SEND_INVITE: "Ibgħat Stqarrija",
		ADMIT: "Ammetti",
		REJECT: "Irrifjuta",
		NO_PARTICIPANTS: "L-ebda parteċipant fil-lobby.",
	},
	CLOSE: "Agħlaq",
	LOGIN_PAGE: {
		CAROUSEL_STORY_1:
			"Esperjenza trascrizzjoni fil-ħin reali b'teknoloġija avvanzata ta' rikonoxximent ta' min jitkellem. Perfett għal laqgħat, intervisti u konferenzi.",
		CAROUSEL_STORY_2:
			"Il-modalità ta' kuntrast għoli, fonts personalizzabbli u appoġġ multilingwi jiżguraw li kulħadd jista' juża l-pjattaforma tagħna b'mod effettiv.",
		CAROUSEL_STORY_3:
			"Il-konversazzjonijiet tiegħek huma protetti b'sigurtà ta' livell ta' intrapriża. Ingħaqad ma' eluf ta' professjonisti li jemmnu f'uTranscribe.",
		CAROUSEL_STORY_4:
			"Agħżel il-metodu ta' identifikazzjoni tiegħek hawn taħt u ibda tittrascrivi fi skejjel. L-ebda konfigurazzjoni kumplessa meħtieġa.",
		CDCR_TEAM_TITLE: "Tim Tech Unicorn",
		CDCR_TEAM_SUBTITLE: "Membru Vverifikat",
		OR_CONTINUE_WITH: "jew kompli ma'",
		GUEST_ACCESS_SUBTITLE: "Mhux membru? Ingħaqad bl-ID tal-laqgħa tiegħek",
		WELCOME_TO: "Merħba f'",
		CHOOSE_IDENTIFICATION: "Jekk jogħġbok agħżel l-identifikazzjoni tiegħek",
		NEED_HELP:
			"Għandek bżonn għajnuna? Ikkonnettja mal-Desk ta' Appoġġ tagħna.",
		CALL_SUPPORT: "Ċempel 1-877-742-2135",
		EMAIL_SUPPORT: "Ibgħat email lil support@courtroom.tech",
	},
	SIZES: "Daqsijiet",
	DIAGNOSTICS: "Dijanjostiċi",
	ROOM_BACKGROUND: "Sfond tal-Kamra",
	NOT_AVAILABLE: "Mhux disponibbli",
	UNRECOGNIZED_SPEECH: "Kundizzjoni mhux rikonoxxita",
	UNRECOGNIZED_SPEECH_TOOLTIP:
		"Din il-trascrizzjoni ma tistax tiġi rikonoxxita. Jekk jogħġbok, tikkontrolla l-kwalità tal-audio u r-rbaħħa.",
	UNDETECTED: "Mhux magħruf",
	MICROPHONE_QUALITY_WARNING:
		"Jekk jogħġbok, ikkontolla l-kwalità tal-mikrofonu biex ittejjeb il-preċiżjoni jew aġġusta d-distanza tal-mikrofonu",
	LOW_ACCURACY_WARNING: "Preċiżjoni baxxa",
	UNKNOWN: "Mhux magħruf",
	TRANSCRIPTION_SETTINGS: {
		TRANSCRIPTION_SETTINGS: "Issettjar tat-traskrizzjoni",
		MODE: "Modalità",
		LIVE_TRANSCRIPTION: "Transkrizzjoni diretta",
		SEGMENTED_TRANSCRIPTION: "Transkrizzjoni segmentata",
		FINAL_TRANSCRIPTION: "Transkrizzjoni finali",
		LIVE_DESC:
			"Ara transkrizzjoni diretta tad-diskors tiegħek f’pannell separat waqt li titkellem. Il-pannell ewlieni juri t-transkrizzjoni finali għall-kelliema kollha.",
		SEGMENTED_DESC:
			"Uri transkrizzjoni temporanja segmentata f’ħin reali, li taġġorna awtomatikament għall-verżjoni finali.",
		FINAL_DESC:
			"Uri biss it-transkrizzjoni finali fil-pannell ewlieni. Ma tintweriex transkrizzjoni diretta.",
		SPEED_VALUE: "Veloċità: {value}x",
		SPEED: "Veloċità",
		FONT_TEST:
			"UTranscribe qed tirrivoluzzjona l-mod kif naqbdu u nifhmu d-diskors.",
		FONT_SIZE: "Daqs tal-font",
		SPEED_DESC: "Veloċità u dewmien tat-traskrizzjoni",
		DELAY_DESC: "Veloċità {speed:number}x = dewmien ta’ {delay:number} sekondi",
	},
	NO_AUDIO: "Ebda awdjo ma nstab",
	NO_AUDIO_DESC:
		"Il-mikrofonu tiegħek mhux imwaqqaf iżda ma nstab l-ebda awdjo. Iċċekkja s-settings tal-mikrofonu jew ibdel għal mikrofonu ieħor.",
	NO_TRANSCRIPTION: "Ebda traskrizzjoni ma nħolqot",
	NO_TRANSCRIPTION_DESC:
		"It-traskrizzjonijiet mhumiex qed jinħolqu. Jekk jogħġbok aġġorna l-paġna.",
	SCROLLING_PAUSED: "L-iskroljar 'l isfel huwa ppawżat",
	RESUME: "Kompli",
} satisfies BaseTranslation;

export default mt;
